import React from 'react';
import PropTypes from 'prop-types';
import Message from 'Components/Modal/Message';

const TribunNonPlayableCouponModal = props => {
  /*const buttonConfig = {
    primary: {
      label: 'Tamam',
      onClick: props.onPrimaryButtonClick
    }
  };*/

  const { errorMessage } = props;

  const message = errorMessage ? errorMessage : 'Oynamak istediğin kuponda başlayan veya bahse kapanan maçlar bulunuyor. Lütfen başka bir kupon oynamayı dene.';

  return (
    <Message type="none">
      <p dangerouslySetInnerHTML={ { __html: message } } />
    </Message>
  );
};

TribunNonPlayableCouponModal.propTypes = {
  errorMessage: PropTypes.string
};

export default TribunNonPlayableCouponModal;
